const CreateHelper = {
  // d : () => {},
  // unique list of elements
  UniqueList: (data, type) => {
    let arr = data.map((d) => d[type]);
    let filtered = arr.filter((v, i, a) => a.indexOf(v) === i).sort();
    return filtered;
  },
  // sum of arr of obj's value
  // adds values by filtering data, SUM(data,"fund_asset_class_focus","Equity")
  // SUM : (data,key,name) => {
  //     let filtered = data.filter(d => d[key] == [name])
  //     return filtered.map(a => a["val"]).reduce((p,c) => p + c * 1,0)
  // },

  //checks maxlimit and data length matches
  securityValidate: ({ maxLimit, tableLength, individualSliderVal }) => {
    // let value = maxLimit * tableLength;
    // let value = (tableLength / maxLimit) * 100
    let value = Math.ceil(individualSliderVal / maxLimit);

    return tableLength >= value ? true : false;
  },

  securityValidate_universe_lite: ({
    maxLength,
    slider_max_value,
    tuner_max_limit,
  }) => {
    let status;
    //maxLength - length of each slider of types which belongs to

    status = slider_max_value <= tuner_max_limit * maxLength ? true : false;

    return status;
  },

  // SUM
  ADD: (data) => {
    return data.map((a) => a["val"]).reduce((p, c) => p + c * 1, 0);
  },
};

export default CreateHelper;



// WEBPACK FOOTER //
// ./src/components/pages/Create/createHelper.js